import type { CubicReviewerPresentation } from '@/app/(home)/inbox/utils/cubic-reviewer-presentation';
import type { PrV2CheckSummary } from '@/lib/pr-v2/check-run-presentation';

import { getCubicReviewerStatusLabel } from '@/app/(home)/inbox/utils/cubic-reviewer-presentation';
import { countOf } from '@/lib/utils/count-of';

/** cubic's review in a word or two, or null where the inbox slot stays blank. */
export function describeCubicIssues(review: CubicReviewerPresentation): string | null {
  switch (review.kind) {
    case 'hidden':
      return null;
    case 'running':
      return 'Reviewing';
    case 'issues':
      return countOf(review.unresolvedCount, 'issue');
    case 'clean':
      return 'No issues';
    case 'failed':
      return getCubicReviewerStatusLabel(review);
  }
}

/** The checks by what needs a look first: failing, then running, else all passed. */
export function describeChecks(checks: PrV2CheckSummary): string {
  if (checks.failed > 0) {
    return `${countOf(checks.failed, 'check')} failing`;
  }
  if (checks.running > 0) {
    return `${countOf(checks.running, 'check')} running`;
  }
  return 'Checks passed';
}
